import { gql } from '@apollo/client';
import { SchemaDataModelFieldsFragment } from './fragments';

export const DATA_MODEL_CREATE = gql`
  mutation DataModelCreate($input: DataModelCreateInput!) {
    dataModelCreate(input: $input) {
      entity {
        ...SchemaDataModelFields
      }
      errors {
        field
        messages
      }
    }
  }
  ${SchemaDataModelFieldsFragment}
`;

export const DATA_MODEL_UPDATE = gql`
  mutation DataModelUpdate($input: DataModelUpdateInput!) {
    dataModelUpdate(input: $input) {
      entity {
        ...SchemaDataModelFields
      }
      errors {
        field
        messages
      }
    }
  }
  ${SchemaDataModelFieldsFragment}
`;
